export default __webpack_public_path__ + "static/media/Rayalaseema.34d8fe16.png";